import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/OrdenCompra/ordencompra';
import Despacho from './despachoNuevo';

const mstp = state => {
    return {...state.ordencompra}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(Despacho)
